module.exports = __webpack_public_path__ + "img/102.4.69655671.png";